module.exports = __webpack_public_path__ + "static/media/tyRed.b7692138.svg";